import React from 'react';
import { persianNumber } from 'helpers/utils/number';
import { Field } from 'formik';
import { FormControl, FormGroup, Label } from 'components/form/Formik';

const SMS_LINES = [
  { value: '989992177346', label: 'خط خدماتی' },
  { value: '989982007292', label: 'خط خدماتی' },
  { value: '9810000300303300', label: 'خط تبلیغاتی' },
  { value: '9810000700707700', label: 'خط خدماتی' },
  { value: '989998623200', label: 'خط تبلیغاتی حساس (مهاجرت)' },
  { value: '9890002673', label: 'مناسب ارسال به باشگاه و بانک ' },
  { value: '989982007293', label: 'مناسب ارسال باشگاه مشتریان' }
];

function SmsLineInput({ sms }) {
  if (!sms) {
    return null;
  }

  return (
    <FormGroup>
      <Label htmlFor="sms_line">نوع خط ارسال</Label>
      <FormControl>
        <Field id="sms_line" name="sms_line" as="select">
          {SMS_LINES.map(({ value, label }) => (
            <option key={value} value={value}>
              {label} ({persianNumber(value)})
            </option>
          ))}
        </Field>
      </FormControl>
    </FormGroup>
  );
}

export default SmsLineInput;
